import React, { useEffect, useState } from 'react';
import MemberLayout from '../../components/MemberLayout';
import { getMyReferrals, getMyProfile } from '../../services/api';

export default function Referral() {
  const [stats, setStats] = useState(null);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    getMyProfile().then((res) => setProfile(res.data)).catch(() => {});
    getMyReferrals().then((res) => setStats(res.data)).catch(() => {});
  }, []);

  const referralLink = profile ? `${window.location.origin}/register?ref=${profile.referralCode}` : '';

  const copyLink = () => {
    navigator.clipboard.writeText(referralLink);
  };

  if (profile && profile.status !== 'ACTIVE') {
    return (
      <MemberLayout title="Referral Programme">
        <div className="card">
          <p>The referral programme is available to active members only. Your current status is <strong>{profile.status}</strong>.</p>
        </div>
      </MemberLayout>
    );
  }

  return (
    <MemberLayout title="Referral Programme">
      <div className="card" style={{ marginBottom: 24, maxWidth: 560 }}>
        <h3>Your Referral Link</h3>
        <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
          <input readOnly value={referralLink} style={{ flex: 1, padding: 10, border: '1.5px solid #d9d5c8', borderRadius: 4 }} />
          <button className="btn btn-outline-dark" onClick={copyLink}>Copy</button>
        </div>
        <p style={{ fontSize: '0.85rem', marginTop: 10 }}>Referral Code: <strong>{profile?.referralCode}</strong></p>
      </div>

      <div className="grid grid-4">
        <div className="card"><div className="stat-label">Total Referred</div><div className="stat-number" style={{ color: 'var(--color-black)', fontSize: '1.8rem' }}>{stats?.totalReferred ?? 0}</div></div>
        <div className="card"><div className="stat-label">Active Referrals</div><div className="stat-number" style={{ color: 'var(--color-black)', fontSize: '1.8rem' }}>{stats?.active ?? 0}</div></div>
        <div className="card"><div className="stat-label">Pending Referrals</div><div className="stat-number" style={{ color: 'var(--color-black)', fontSize: '1.8rem' }}>{stats?.pending ?? 0}</div></div>
        <div className="card"><div className="stat-label">Commission Available</div><div className="stat-number" style={{ color: 'var(--color-black)', fontSize: '1.8rem' }}>R{Number(stats?.commissionAvailable ?? 0).toFixed(2)}</div></div>
      </div>
      <p style={{ fontSize: '0.85rem', marginTop: 16, color: 'var(--color-grey)' }}>
        Commission is credited once your referred member is approved by our team. Withdrawals are coming in a future update.
      </p>
    </MemberLayout>
  );
}
